import { useMemo } from 'react';
import { useAppSelector } from '../hook/useAppSelector';
import { filterVisibleColumns } from '../util/filter-columns';

export const usePageVisibleColumns = () => {
  const columns = useAppSelector((state) => state.configSlice.columnsByPage);
  const pageKey = useAppSelector((state) => state.configSlice.activePageKey);
  const visibleColumns = useMemo(() => {
    return filterVisibleColumns(columns?.[pageKey] ?? []);
  }, [columns, pageKey]);

  return {
    columns,
    visibleColumns,
    pageKey,
  };
};
